import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInvoiceDetails } from './useInvoiceDetails';

const InvoiceDetails: React.FC = () => {
  const { user, invoices, loaded, handleSendInvoice, sendingId } = useInvoiceDetails();
  const [t] = useTranslation();

  if (!loaded) {
    return (
      <div className="card card-body pt-10 text-center">
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  return (
    <div className="card card-body pt-10">
      <h3 className="mb-4">
        {t('dashboard.invoicesPage.invoicesFor')} {user?.username || ''}
      </h3>
      {user && (
        <div className="mb-3">
          <strong>Email:</strong> {user.email}
        </div>
      )}

      {invoices.length === 0 ? (
        <div className="alert alert-info">
          {t('dashboard.invoicesPage.noInvoices')}
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t('dashboard.invoicesPage.reference')}</th>
                <th>{t('dashboard.invoicesPage.invoiceTitle')}</th>
                <th>{t('dashboard.invoicesPage.date')}</th>
                <th>{t('dashboard.invoicesPage.stripeReceipt')}</th>
                <th>{t('dashboard.invoicesPage.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice._id}>
                  <td>#{invoice.reference}</td>
                  <td>{invoice.title || '-'}</td>
                  <td>
                    {invoice.createdAt
                      ? new Date(invoice.createdAt).toLocaleDateString('fr-FR')
                      : '-'}
                  </td>
                  <td>
                    {invoice.stripeInvoiceUrl ? (
                      <a
                        href={invoice.stripeInvoiceUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary btn-sm"
                      >
                        <i className="fas fa-external-link-alt mr-1" />
                        {t('dashboard.invoicesPage.stripeReceipt')}
                      </a>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => handleSendInvoice(invoice._id)}
                      disabled={sendingId === invoice._id}
                    >
                      {sendingId === invoice._id ? (
                        <span
                          className="spinner-border spinner-border-sm mr-1"
                          role="status"
                        />
                      ) : (
                        <i className="fas fa-envelope mr-1" />
                      )}
                      {t('dashboard.invoicesPage.sendEmail')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default InvoiceDetails;
